__turbopack_context__.v({
  "contactCapi": "contactCapi-module-scss-module__k-pjHq__contactCapi",
  "contactInfo": "contactCapi-module-scss-module__k-pjHq__contactInfo",
  "image": "contactCapi-module-scss-module__k-pjHq__image",
  "intro": "contactCapi-module-scss-module__k-pjHq__intro",
});
